
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSupabaseAuth } from "@/hooks/auth";
import { Loader2 } from "lucide-react";

const SignUp = () => {
  const navigate = useNavigate();
  const { session, user } = useSupabaseAuth();

  // Redirect if already authenticated
  useEffect(() => {
    if (session && user) {
      navigate("/", { replace: true });
      return;
    }
    
    // Redirect to login page 
    navigate("/login", { replace: true });
  }, [session, user, navigate]);

  // Show loading while redirecting
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-secondary/30">
      <div className="text-center">
        <Loader2 className="h-12 w-12 animate-spin mx-auto mb-4 text-primary" />
        <h2 className="text-xl font-semibold">Redirecting to Sign In...</h2>
      </div>
    </div>
  );
};

export default SignUp;
